"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IExternalComponentSchema = void 0;
const zod_1 = require("zod");
const BoundaryLevel_1 = require("../BoundaryLevel");
const NumericalBoundary_1 = require("../NumericalBoundary");
const FunctionReferenceCondition_1 = require("./FunctionReferenceCondition");
const TraversalHelpers_1 = require("./TraversalHelpers");
const IExternalComponetConnection_1 = require("./IExternalComponetConnection");
const TraversalSolvableCharacteristic_1 = require("./TraversalSolvableCharacteristic");
exports.IExternalComponentSchema = zod_1.z.object({
    name: zod_1.z.string(),
    model: zod_1.z.string().optional(),
    rootComponentSignalId: zod_1.z.string().optional(),
    traversalType: zod_1.z
        .union([TraversalSolvableCharacteristic_1.TraversalSolvableCharacteristicSchema, TraversalHelpers_1.TraversalSolvableCharacteristicMatcherSchema])
        .optional(),
    functionClass: zod_1.z.string().optional(),
    functionSignal: zod_1.z.string().optional(),
    isPassive: zod_1.z.boolean().optional(),
    count: zod_1.z.union([zod_1.z.literal(1), zod_1.z.literal('many')]).optional(),
    value: NumericalBoundary_1.NumericalBoundarySchema.optional(),
    connectedFunction: FunctionReferenceCondition_1.FunctionReferenceConditionSchema.optional(),
    valueLevel: BoundaryLevel_1.BoundaryLevelSchema.optional(),
    withConnections: zod_1.z
        .lazy(() => IExternalComponetConnection_1.IExternalComponetConnectionSchema)
        .array()
        .optional(),
});
//# sourceMappingURL=IExternalComponent.js.map